<div class="page-data">
    <app-advanced-search (formData)="applyFilters($event)" [config]="filterConfig"> </app-advanced-search>
    @if (canUsePaymentDevice) {
        <div class="mrb-1">
            <button mat-flat-button color="accent" type="button" (click)="syncExternalPrices()">Загрузить прайсы из кассы</button>
        </div>
    }
    <div class="p-relative c-table">
        <app-loader [isLoading]="priceTableService.loading()" />
        <app-common-table
            [config]="tableConfig"
            [service]="priceTableService"
            (actions)="applyAction($event)"
        >
        </app-common-table>
    </div>
</div>
